/**
 * Shared table chrome for pool reports (annual + monthly tabs).
 * Compact headers; body padding aligned for consistent row rhythm.
 */

/** Owner-summary first column header (Contribution, Distribution, Net allocation, Offhire owner list) */
export const POOL_REPORT_OWNER_COL_HEADER = 'Owner name';

/** Drill-down first column (vessel rows) */
export const POOL_REPORT_VESSEL_COL_HEADER = 'Vessel name';

/** Sticky thead on owner-summary tables */
export const poolReportTheadStickyClass =
  'sticky top-0 z-[9999] border-b border-gray-200 bg-gray-100/95 dark:border-dark-700 dark:bg-dark-900/95';

/** Non-sticky thead (loading, some drill-down layouts) */
export const poolReportTheadMutedClass =
  'border-b border-gray-200 bg-gray-100/90 dark:border-dark-700 dark:bg-dark-900/70';

/** Drill-down / nested tables */
export const poolReportTheadDrilldownClass =
  'border-b border-gray-200 bg-gray-50 dark:border-dark-700 dark:bg-dark-800';

/** Compact header cell — default (numeric columns) */
export const poolReportThClass =
  'border-b border-gray-200 px-2.5 py-1.5 text-right align-bottom text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-700 dark:border-dark-700 dark:text-gray-300 sm:px-3 sm:py-2 sm:text-xs';

/** Slightly stronger weight (owner summary main tabs) */
export const poolReportThEmphasisClass =
  'border-b border-gray-200 px-2.5 py-1.5 text-right align-bottom text-[10px] font-bold uppercase leading-tight tracking-wide text-gray-600 dark:border-dark-700 dark:text-gray-300 sm:px-3 sm:py-2 sm:text-xs';

/** First column / period label (summary breakdown — sentence case) */
export const poolReportThLabelClass =
  'border-b border-gray-200 px-2.5 py-1.5 text-left align-bottom text-[10px] font-semibold leading-tight tracking-wide text-gray-600 dark:border-dark-700 dark:text-gray-300 sm:px-3 sm:py-2 sm:text-xs';

/** Sticky period column uppercase (distribution / other) */
export const poolReportThPeriodClass =
  'border-b border-gray-200 px-2.5 py-1.5 text-left align-bottom text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-600 dark:border-dark-700 dark:text-gray-300 sm:px-3 sm:py-2 sm:text-xs';

/** Stacked unit line under header title */
export const poolReportThUnitClass =
  'mt-0.5 block text-[9px] font-medium normal-case tracking-normal opacity-80 sm:text-[10px]';

/** Offhire-style group header (two-row header) */
export const poolReportThGroupClass =
  'border-b border-gray-200 px-2 py-1 text-center align-middle text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-700 dark:border-dark-700 dark:text-gray-300 sm:px-2.5 sm:py-1.5 sm:text-xs';

export const poolReportThGroupSideClass =
  'border-b border-gray-200 px-2 py-1 text-right align-middle text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-700 dark:border-dark-700 dark:text-gray-300 sm:px-2.5 sm:py-1.5 sm:text-xs';

export const poolReportThGroupLeftClass =
  'border-b border-gray-200 px-2 py-1 text-left align-middle text-[10px] font-semibold uppercase leading-tight tracking-wide text-gray-700 dark:border-dark-700 dark:text-gray-300 sm:px-2.5 sm:py-1.5 sm:text-xs';

/** Body cell padding (owner summary style, border-t rows) */
export const poolReportTdPadClass =
  'border-t px-2.5 py-2 text-right align-top text-sm sm:px-3 sm:py-2.5';

/** Body cell — drill-down tables (divide-y or border-t) */
export const poolReportTdDrilldownClass =
  'px-2.5 py-2 text-right align-top text-sm tabular-nums text-gray-900 dark:text-white sm:px-3 sm:py-2.5';
